import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { MinusIcon, PlusIcon } from '@heroicons/react/outline'

const FAQ = ({ title, description, setFaq, activeFaq, id }) => {
    const isOpen = activeFaq?.id === id

    return (
        <div className="h-auto w-full rounded-2xl border border-grayLines overflow-hidden transition-all">
            <div
                className={clsx(
                    'w-full flex flex-row items-center justify-between p-4 gap-x-12 transition-all',
                    isOpen
                        ? 'bg-black70 border-grayLines border-b'
                        : 'bg-white',
                )}
                onClick={() => setFaq(id)}
            >
                <span
                    className={clsx(
                        'flex-grow max-w-full font-normal text-base transition-all',
                        isOpen ? 'text-white' : 'text-black50',
                    )}
                >
                    {title}
                </span>
                <p
                    role="button"
                    // onClick={() => setFaq(id)}
                    className={clsx(
                        'w-6 h-6 p-0 select-none rounded-full min-w-6 min-h-6 cursor-pointer border flex flex-col items-center justify-center',
                        isOpen
                            ? ' border-yellow bg-yellow bg-opacity-5'
                            : 'border-grayLines bg-pgBackground',
                    )}
                >
                    {isOpen ? (
                        <MinusIcon className="w-3 text-white" />
                    ) : (
                        <PlusIcon className="w-3 text-black30" />
                    )}
                </p>
            </div>
            <div
                className={clsx(
                    'text-left transition-all bg-white text-black30 text-base leading-4.68 font-normal',
                    isOpen ? 'px-4 py-6 h-auto' : 'h-0',
                )}
            >
                {isOpen && description}
            </div>
        </div>
    )
}

FAQ.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    description: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.element,
    ]),
    setFaq: PropTypes.func,
    activeFaq: PropTypes.object,
    id: PropTypes.number,
}

export default FAQ
